<template lang="pug">

    .field
        label Sorten
        text-field(
            label=''
            v-for='(sort, index) in models'
            v-bind:key='index'
            v-model='models[index]'
        )

        .field
            .ui.grid
                .right.aligned.column
                    a.ui.right.labeled.icon.button(v-on:click='remove()' v-show="models.length > 1")
                        i.remove.icon
                        | Sorte entfernen
                    a.ui.right.labeled.icon.button(v-on:click='add()')
                        i.plus.icon
                        | Sorte hinzufügen

</template>

<script>
    import isEqual from 'lodash/fp/isEqual'
    import TextField from '../../../form/TextField.vue'

    //noinspection JSUnusedGlobalSymbols
    export default {

        components: { TextField },

        created() {
            this.models = [...this.value]

            // ggf. leeres Default-Feld hinzufuegen
            if (this.models.length === 0) {
                this.models.push('')
            }
        },

        data() {
            return {
                models: []
            }
        },

        methods: {

            add() {
                this.models.push('')
            },

            remove() {
                this.models = this.models.slice(0, this.models.length-1)
            },

            updateValue(value, index) {
                const models = [...this.models]
                models[index] = value
                this.$emit('input', models)
            }

        },

        props: {
            value: {
                type: Array,
                required: true
            }
        },

        watch: {
            models(value){
                this.$emit('input', [...value])
            },
            value(value) {
                if (!isEqual(value, this.models)) {
                    this.models = [...value]
                }
            }
        }

    }

</script>
